<template>
  <v-container>
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="12">
        <v-card outlined>
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12" md="12" v-if="alertdata.show">
                <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
              </v-col>
              <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
              <v-col cols="12" md="12" v-if="!loading.detail && detaildata.length > 0">
                <v-row>
                  <v-col cols="12" md="12">
                    <p class="subtitle-1">
                      <span class="font-weight-bold text-decoration-underline">{{ detaildata[0].top_title }}</span>
                    </p>
                    <v-simple-table class="style-tbl-quest">
                      <template v-slot:default>
                        <tbody>
                          <div
                            v-for="(soal, i) in detaildata"
                            :key="i"
                            class="mb-3">
                            <tr>
                              <td style="width: 20px">{{ i+1 }}.</td>
                              <td v-html="soal.que_text"></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>A. <input type="radio" value = "a" :name = "'soal-' + i" v-model="pilih[i]"> {{ soal.que_a }}</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>B. <input type="radio" value = "b" :name = "'soal-' + i" v-model="pilih[i]"> {{ soal.que_b }}</td>
                            </tr>
                            <tr v-if="soal.que_c">
                              <td></td>
                              <td>C. <input type="radio" value = "c" :name = "'soal-' + i" v-model="pilih[i]"> {{ soal.que_c }}</td>
                            </tr>
                            <tr v-if="soal.que_d">
                              <td></td>
                              <td>D. <input type="radio" value = "d" :name = "'soal-' + i" v-model="pilih[i]"> {{ soal.que_d }}</td>
                            </tr>
                            <tr v-if="soal.que_e">
                              <td></td>
                              <td>E. <input type="radio" value = "e" :name = "'soal-' + i" v-model="pilih[i]"> {{ soal.que_e }}</td>
                            </tr>
                            <tr v-if="pilih[i]">
                              <td></td>
                              <td>
                                <v-icon
                                  v-if="soal.que_ans === pilih[i]"
                                  color="green">
                                  mdi-check-circle
                                </v-icon>
                                <v-icon
                                  v-if="soal.que_ans !== pilih[i]"
                                  color="red">
                                  mdi-close-circle
                                </v-icon>
                              </td>
                            </tr>
                            <tr v-if="pilih[i]">
                              <td></td>
                              <td>
                                Correct answer: <b><span class="text-uppercase">{{ soal.que_ans }}</span>. {{ soal.que_ans === 'a' ? soal.que_a : (soal.que_ans === 'b' ? soal.que_b : (soal.que_ans === 'c' ? soal.que_c : (soal.que_ans === 'd' ? soal.que_d : soal.que_e))) }}</b>
                              </td>
                            </tr>
                            <tr v-if="pilih[i]">
                              <td></td>
                              <td class="font-weight-bold" v-html="soal.que_desc"></td>
                            </tr>
                          </div>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions v-if="!loading.detail">
            <v-btn
              icon
              @click="$router.go(-1)"
              exact>
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <span>Back</span>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Questiondetail',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    panduan: null,
    paramdata: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      vocab: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    pilih: [],
  }),
  watch: {
    '$route.query.vocab'(val) {
      if (val) {
        this.check.vocab = val;
        this.getData();
      }
    },
  },
  mounted() {
    if (this.$route.query.vocab && this.$route.query.vocab !== '') {
      this.check.vocab = this.$route.query.vocab;
      this.getData();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'isFavorite',
    ]),
  },
  methods: {
    getData() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.vocab) {
        this.axios
          .get(
            this.api + '/public/question/' + this.check.vocab,
            {
              params: this.paramdata,
              headers: {
                Authorization: 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.$store.commit('UPDATE_TITLE', 'QUESTION');
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Berita tidak ditemukan!';
      }
    },
    addFavorite(datafav, status) {
      // favorite
      const favNew = {
        id_vocab: datafav.id_vocab,
        top_title: datafav.top_title,
      };
      if (status === true) {
        // delete
        this.$store.commit('DEL_FAV', favNew);
      } else {
        // add
        this.$store.commit('ADD_FAV', favNew);
      }
      // update favorite
      this.$store.commit('UPDATE_FAV', datafav.id_vocab);
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
